<template lang="pug">
    div.col-md-10.col-sm-12(style="margin:0 auto")
        form-insert(:IsShowModal.sync="IsShowModalInsert",:nameModulo="nameModulo",:parameter.sync="parameterInsert", @sendInfo="val => Insert(val)")
        form-update(:IsShowModal.sync="IsShowModalUpdate",:nameModulo="nameModulo",:parameter.sync="parameterUpdate", @sendInfo="val => Update(val)")
        .card.bg-menu.text-white.form-group.col-md-4.col-sm-12(v-if="IsShowEnterprise")
            .card-body  
                label Selecion de Empresa
                select.form-control.form-control-sm(v-if="tableEnterprise", v-model="selectEnterprise",@change="setEnterprise()")
                    option(v-for="(item,index) in tableEnterprise", :value="item.IdEnterprise") {{item.BusinessName}} 
        .card
            .card-header.bg-menu.text-white
                .card-title
                    .form-row
                        .col-md-9.col-sm-12
                            h4 Mantenedor {{nameModulo}}
                        .col-md-3.col-sm-12.text-right
                            button.btn.btn-sm.btn-primary.text-light(@click="IsShowModalInsert=true") Crear {{nameModulo}} 
                                i.fa.fa-plus-circle
            form-view(:parameter.sync="parameterView",:tablaInfo.sync="tableInfo", @sendSearch="val => List_Info(val)", @sendInfo="val => {IsShowModalUpdate=true,parameterUpdate=val}" ) 

</template>
<script> 
import apiWeb from "../../api/apiSLC.js"
import model from "../../models/branchOffices.js"
import modelEnterprise from "../../models/enterprise.js"
import formInsert from './components/insert.vue'
import formUpdate from './components/update.vue'
import formView from './components/view.vue'
export default {
    components:{
                formInsert,
                formUpdate,
                formView
    },
    data(){
        return{
                nameModulo:'Sucursal',
                pathApi:'BranchOffices/BranchOffices',
                selectEnterprise:'0',
                tableEnterprise:[],
                IsShowModalInsert:false,
                IsShowModalUpdate:false,
                parameterUpdate:Object.assign({}, model.parameterUpdate),
                parameterInsert:Object.assign({}, model.parameterInsert),
                parameterView:Object.assign({}, model.parameterView),
                tableInfo:[],
                IsShowEnterprise:false
        }
    },
    mounted(){ 
        if(this.$info.idEnterprise==1 && this.$info.typeAccount==4){
            this.List_Enterprise()
            this.IsShowEnterprise=true
        }
        else{
            this.IsShowEnterprise=false
            this.selectEnterprise=this.$info.idEnterprise
        }
        this.setEnterprise()         
    },
    methods:{        
        List_Enterprise(){
            apiWeb.post("Enterprise/Enterprise_View",{ RUT:'',BusinessName:'',Active:'1'})
                    .then(result=>{
                                if(result.status==0){ 
                                    this.tableEnterprise=JSON.parse(result.value)
                                    if(this.selectEnterprise=='' && this.tableEnterprise.length>0)
                                        this.selectEnterprise=this.tableEnterprise[0].IdEnterprise
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        }, 
        setEnterprise(){            
            this.parameterView.IdEnterprise=this.selectEnterprise
            this.parameterInsert.IdEnterprise=this.selectEnterprise
            this.parameterUpdate.IdEnterprise=this.selectEnterprise
            this.List_Info()
        },
        List_Info(){
            this.parameterView.IdEnterprise=this.selectEnterprise
            apiWeb.post(this.pathApi + "_View",this.parameterView)
                    .then(result=>{
                                if(result.status==0){
                                    this.tableInfo=JSON.parse(result.value) 
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        Insert(){
            this.parameterInsert.IdEnterprise=this.selectEnterprise
            this.parameterInsert.User=this.$info.email
            this.parameterInsert.IP=this.$info.ip
            apiWeb.post(this.pathApi +"_Insert",this.parameterInsert)
                    .then(result=>{ 
                            if(result.status==0){
                                this.List_Info()
                                this.IsShowModalInsert=false
                                this.parameterInsert=Object.assign({}, model.parameterInsert)
                                this.parameterInsert.IdEnterprise=this.selectEnterprise
                                this.$msgbox.show("Ingresado","Notificacion")
                            }
                            else{
                                this.$msgbox.show(result.message,"Error nivel 1")
                            }

                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        Update(){
            this.parameterUpdate.IdEnterprise=this.selectEnterprise
            this.parameterUpdate.User=this.$info.email
            this.parameterUpdate.IP=this.$info.ip
            apiWeb.post(this.pathApi + "_Update",this.parameterUpdate)
                    .then(result=>{ 
                             if(result.status==0){
                                this.List_Info()
                                this.IsShowModalUpdate=false
                                this.$msgbox.show("Actualizado","Notificacion")
                            }
                            else{
                               this.$msgbox.show(result.message,"Error nivel 1")
                            }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        }
    }
}
</script>